<template>
  <div class="facility-page">
    <front-navigation></front-navigation>

    <div class="facility-container">
      <!-- Image Gallery Section -->
      <div class="gallery-section">
        <div v-if="facilityImages && facilityImages.length > 0" class="gallery-container">
          <div class="image-navigation">
            <button class="nav-button prev" @click="prevImage" :disabled="currentImageIndex === 0">
              <v-icon>chevron_left</v-icon>
            </button>

            <div class="image-wrapper">
              <img :src="facilityImages[currentImageIndex].path" class="gallery-image" alt="Facility image">
            </div>

            <button class="nav-button next" @click="nextImage" :disabled="currentImageIndex === facilityImages.length - 1">
              <v-icon>chevron_right</v-icon>
            </button>
          </div>

          <div class="image-counter">
            {{ currentImageIndex + 1 }} / {{ facilityImages.length }}
          </div>
        </div>
        <div v-else class="single-image-container">
          <img :src="singleFacility.thumbnail" class="gallery-image" alt="Facility thumbnail">
        </div>
      </div>

      <!-- Facility Details Section -->
      <div class="details-section">
        <div class="details-header">
          <h1 class="facility-title earthwerk-font">{{singleFacility.name.toUpperCase()}}</h1>

          <div class="capacity-display">
            <div class="capacity-item">
              <span class="capacity-label">Maximum Capacity:</span>
              <span class="capacity-value">{{singleFacility.maximum_guests}} Guests</span>
            </div>
          </div>
        </div>

        <div class="description-section" v-html="singleFacility.description"></div>

        <v-btn color="primary"
               large
               dark
               class="book-now-btn earthwerk-font"
               @click="dialog = true">
          BOOK NOW
        </v-btn>
      </div>
    </div>

    <!-- Booking Dialog -->
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card class="booking-dialog">
        <v-card-title class="dialog-header">
          <h2 class="earthwerk-font">BOOKING DETAILS</h2>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-tabs color="primary" dark slider-color="primary">
            <v-tab key="availability" class="earthwerk-font">Accommodation Availability</v-tab>
            <v-tab key="conservation" class="earthwerk-font">Conservation Fees</v-tab>

            <!-- Availability Tab -->
            <v-tab-item key="availability">
              <div class="tab-content">
                <div class="date-pickers">
                  <v-dialog ref="dialog3"
                            persistent
                            v-model="modal4"
                            lazy
                            full-width
                            width="290px"
                            :return-value.sync="facility.start_date">
                    <v-text-field slot="activator"
                                  label="Start Date *"
                                  v-model="facility.start_date"
                                  readonly
                                  prepend-icon="event"
                                  class="date-input"></v-text-field>
                    <v-date-picker v-model="facility.start_date"
                                   scrollable
                                   :min="a_start_date">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal4 = false" class="earthwerk-font">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog3.save(facility.start_date)" class="earthwerk-font">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-dialog ref="dialog4"
                            persistent
                            v-model="modal3"
                            lazy
                            full-width
                            width="290px"
                            :return-value.sync="facility.end_date">
                    <v-text-field slot="activator"
                                  label="End Date *"
                                  v-model="facility.end_date"
                                  readonly
                                  id="activity_date"
                                  prepend-icon="event"
                                  class="date-input"></v-text-field>
                    <v-date-picker v-model="facility.end_date"
                                   scrollable
                                   :min="facility.start_date"
                                   @input="searchFacilityAvailability()">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal3 = false" class="earthwerk-font">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog4.save(facility.end_date)" class="earthwerk-font">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>

                <div class="participant-selectors" v-if="showDates">
                  <div class="selector-group">
                    <v-autocomplete label="Children"
                                    :items="childSlots"
                                    v-model="facility.children"
                                    :disabled="facility.end_date.length === 0"
                                    prepend-icon="child_friendly"
                                    class="participant-input"></v-autocomplete>

                    <v-autocomplete label="Adults"
                                    :items="adultSlots"
                                    v-model="facility.adults"
                                    :disabled="facility.end_date.length === 0"
                                    prepend-icon="person"
                                    class="participant-input"></v-autocomplete>
                  </div>
                </div>

                <div v-if="singleFacility.accomodation_type_id === 'Pelican'" class="catering-options">
                  <v-select label="Catering Type"
                            :items="cateringType"
                            item-text="name"
                            item-value="public_id"
                            v-model="facility.catering_type"
                            prepend-icon="restaurant"
                            class="option-input"></v-select>
                </div>
              </div>
            </v-tab-item>

            <!-- Conservation Fees Tab -->
            <v-tab-item key="conservation">
              <div class="tab-content">
                <div class="notice-text">
                  * Conservation fees are required for your stay *
                </div>

                <div class="date-pickers">
                  <v-dialog ref="dialog"
                            persistent
                            v-model="modal1"
                            lazy
                            full-width
                            width="290px"
                            :return-value.sync="facility.check_in">
                    <v-text-field slot="activator"
                                  label="Check-in *"
                                  v-model="facility.check_in"
                                  readonly
                                  :disabled="facility.end_date.length === 0"
                                  prepend-icon="event"
                                  class="date-input"></v-text-field>
                    <v-date-picker v-model="facility.check_in"
                                   :min="facility.start_date"
                                   scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal1 = false" class="earthwerk-font">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog.save(facility.check_in)" class="earthwerk-font">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-dialog ref="dialog1"
                            persistent
                            v-model="modal2"
                            lazy
                            full-width
                            width="290px"
                            :return-value.sync="facility.check_out">
                    <v-text-field slot="activator"
                                  label="Check-out *"
                                  v-model="facility.check_out"
                                  readonly
                                  :disabled="facility.end_date.length === 0"
                                  prepend-icon="event"
                                  class="date-input"></v-text-field>
                    <v-date-picker v-model="facility.check_out"
                                   :min="facility.check_in"
                                   scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal2 = false" class="earthwerk-font">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog1.save(facility.check_out)" class="earthwerk-font">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>

                <div class="fee-sections">
                  <div class="fee-section">
                    <h3 class="earthwerk-font">Conservation entry fees</h3>
                    <guests></guests>
                  </div>

                  <div class="fee-section">
                    <h3 class="earthwerk-font">Vehicle entry fees</h3>
                    <vehicle />
                  </div>
                </div>

                <small class="required-notice">*indicates required field</small>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="dialog = false" class="cancel-btn earthwerk-font">Cancel</v-btn>
          <v-btn color="primary" @click="addAccommodation()" class="reserve-btn earthwerk-font">Make Reservation</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import FrontNavigation from './../Repeated/FrontNavigation'
  import Guests from '../Repeated/Guests'
  import Vehicle from '../Repeated/Vehicle'

  export default {
    data() {
      return {
        active: false,
        menu1: false,
        modal1: false,
        menu2: false,
        modal2: false,
        a_start_date: this.$moment().format('YYYY-MM-DD'),
        adjust: false,
        switch1: true,
        dialog: false,
        dialog4: false,
        modal3: false,
        modal4: false,
        dialog3: false,
        continue_: false,
        showDates: false,
        loadingdialog_: false,
        totalCount: 0,
        currentImageIndex: 0,
        facility: {
          start_date: '',
          end_date: '',
          days: 0,
          check_in: '',
          check_out: '',
          currency: localStorage.getItem('currency'),
          activity_date: '',
          children: 0,
          adults: 0,
          catering_type: '',
          accommodation: {}
        }
      }
    },
    beforeCreate() {
      this.$store.dispatch('get_facility', this.$route.params.facility_id)
      this.$store.dispatch('get_facility_images', this.$route.params.facility_id)
    },
    computed: {
      facilityImages() {
        return this.$store.state.FacilityStore.facility_images
      },
      singleFacility() {
        return this.$store.state.FacilityStore.facility
      },
      childSlots() {
        var slots = []
        var available = this.calculateChildMax
        for (var i = 0; i <= available; i++) {
          slots.push(i)
        }
        return slots
      },
      adultSlots() {
        var slots = []
        var available = this.calculateAdultMax
        for (var i = 0; i <= available; i++) {
          slots.push(i)
        }
        return slots
      },
      cateringType() {
        var normalPricing = []
        var length = this.$allPricingGroups.length
        for (var i = 0; i < length; i++) {
          if (i < 3) {
            normalPricing.push(this.$allPricingGroups[i])
          }
        }
        var route = this.$route.name
        if (route === 'NewBooking' || route === 'EditBooking') {
          return this.$allPricingGroups
        } else {
          return normalPricing
        }
      },
      calculateAdultMax: function () {
        return (Number(this.singleFacility.maximum_guests) - Number(this.total)) + this.facility.adults
      },
      calculateChildMax: function () {
        return (Number(this.singleFacility.maximum_guests) - Number(this.total)) + this.facility.children
      },
      total: function () {
        return Number(this.facility.adults) + Number(this.facility.children)
      }
    },
    methods: {
      prevImage() {
        if (this.currentImageIndex > 0) {
          this.currentImageIndex--
        }
      },
      nextImage() {
        if (this.currentImageIndex < this.facilityImages.length - 1) {
          this.currentImageIndex++
        }
      },
      searchFacilityAvailability: function () {
        var data = {
          check_in_date: this.facility.start_date,
          check_out_date: this.facility.end_date
        }
        this.$store.dispatch('check_date_facility_availability', data)
        this.$store.dispatch('get_facility', this.$route.params.facility_id)
        this.showDates = true
      },
      addAccommodation: function () {
        var facility = this.$store.state.FacilityStore.facility

        if (facility.pricing_status === 'false') {
          this.$notify({
            type: 'warning',
            group: 'foo',
            title: 'Pricing Error',
            text: 'No pricing has been set for this period',
            classes: 'alert-wrapper'
          })
        } else if (facility.accomodation_type_id === 'Pelican' && this.facility.catering_type !== '9a9a77eb' && this.facility.catering_type !== '266677c3' && facility.group_pricing_status === 'false') {
          this.$notify({
            type: 'warning',
            group: 'foo',
            title: 'Pricing Error',
            text: 'No special Pricing available for the selected Accommodation',
            classes: 'alert-wrapper'
          })
        } else {
          var data = {
            public_id: facility.public_id,
            catering_type: this.facility.catering_type,
            facility_type: facility.facility_type_id,
            accommodation_type: facility.accomodation_type_id,
            start_date: this.facility.start_date,
            end_date: this.facility.end_date,
            name: facility.name,
            children: this.facility.children,
            adults: this.facility.adults,
            discounts: facility.discount,
            discount_status: facility.discount_status
          }

          if (facility.accomodation_type_id === 'Pelican') {
            var priceIndex
            var currencyList = []
            if (this.facility.catering_type === '9a9a77eb') {
              facility.price.map(function (item, index) {
                if (item.hasOwnProperty('lower_limit_list') && item.lower_limit_list.length > 0) {
                  priceIndex = index
                  currencyList = item.upper_currency
                }
              })
            } else if (this.facility.catering_type === '266677c3') {
              facility.price.map(function (item, index) {
                if (item.hasOwnProperty('upper_upper_limit_list') && item.upper_upper_limit_list.length > 0) {
                  priceIndex = index
                  currencyList = item.lower_currency
                }
              })
            }
            var pelicanPricing = {
              pack_prices: facility.price[priceIndex],
              pack_currency: facility.price[priceIndex],
              pelican_lower_currency: currencyList
            }
            Object.assign(data, pelicanPricing)
          } else if (facility.accomodation_type_id === 'Stables') {
            switch (facility.quantity) {
              case '1':
                var SingleRoomPricing = {
                  quantity: facility.quantity,
                  child_price: facility.price[0].child_price,
                  mandatory_price: facility.price[0].mandatory_price,
                  currency: facility.price[0].currency_type,
                  adult_price: facility.price[0].mandatory_price * this.facility.adults
                }
                Object.assign(data, SingleRoomPricing)
                break
              default:
                var _nonPelicanPricing = {
                  adult_price: facility.price[0].adult_price,
                  child_price: facility.price[0].child_price,
                  mandatory_price: facility.price[0].mandatory_price,
                  currency: facility.price[0].currency_type
                }
                Object.assign(data, _nonPelicanPricing)
            }
          } else {
            var nonPelicanPricing = {
              adult_price: facility.price[0].adult_price,
              child_price: facility.price[0].child_price,
              mandatory_price: facility.price[0].mandatory_price,
              currency: facility.price[0].currency_type
            }
            Object.assign(data, nonPelicanPricing)
          }

          if (facility.group_pricing_status === 'true' && this.facility.catering_type !== '9a9a77eb' && this.facility.catering_type !== '266677c3') {
            var extraData = {
              extra_price: facility.group_price[this.findGroup(facility)].extra_price,
              special_mandatory_price: facility.group_price[this.findGroup(facility)].mandatory_price,
              special_currency: facility.group_price[this.findGroup(facility)].currency_type,
              from_number: facility.group_price[this.findGroup(facility)].from_number,
              to_number: facility.group_price[this.findGroup(facility)].to_number,
              maximum_number: facility.group_price[this.findGroup(facility)].maximum_number
            }
            Object.assign(data, extraData)
          }

          var oldData = JSON.parse(localStorage.getItem('facility_data'))
          this.$store.commit('BROWSER_FACILITIES', oldData)
          this.$store.commit('ADD_FACILITY', data)
          localStorage.setItem('facility_data', JSON.stringify(this.chosenFacilities))
          this.$router.push({
            name: 'Reservation'
          })
        }
      },
      findGroup(facility) {
        var total = this.facility.adults + this.facility.children
        for (var i = 0; i < facility.group_price.length; i++) {
          if (total >= facility.group_price[i].from_number && total <= facility.group_price[i].to_number) {
            return i
          }
        }
        return 0
      }
    },
    components: {
      FrontNavigation,
      Guests,
      Vehicle
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('/fonts/Earthwerk.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    letter-spacing: 1px;
  }

  .facility-page {
    background-color: #f9f9f9;
    min-height: 100vh;
  }

  .facility-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .gallery-section {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .gallery-container, .single-image-container {
    width: 100%;
    height: 500px;
  }

  .image-navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    position: relative;
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

    .nav-button:hover {
      background: rgba(255, 255, 255, 0.9);
    }

    .nav-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .nav-button.prev {
      left: 20px;
    }

    .nav-button.next {
      right: 20px;
    }

  .image-counter {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 10;
  }

  .details-section {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .details-header {
    margin-bottom: 25px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }

  .facility-title {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 32px;
    margin-bottom: 15px;
    letter-spacing: 0.5px;
  }

  .capacity-display {
    display: flex;
    gap: 20px;
    margin-top: 15px;
  }

  .capacity-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .capacity-label {
    font-size: 16px;
    color: #666;
  }

  .capacity-value {
    font-size: 18px;
    font-weight: 600;
    color: #74a533;
  }

  .description-section {
    color: #555;
    line-height: 1.8;
    font-size: 16px;
    margin-bottom: 30px;
  }

    .description-section > > > p {
      margin-bottom: 15px;
    }

    .description-section > > > a {
      color: #74a533;
      text-decoration: none;
    }

      .description-section > > > a:hover {
        text-decoration: underline;
      }

  .book-now-btn {
    margin-top: 20px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .booking-dialog {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .dialog-header {
    background-color: #74a533;
    color: white;
    padding: 20px 24px;
  }

    .dialog-header h2 {
      font-family: 'Earthwerk', sans-serif;
      font-size: 24px;
      margin: 0;
    }

  .dialog-content {
    padding: 24px;
  }

  .tab-content {
    padding: 15px 0;
  }

  .notice-text {
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 6px;
  }

  .date-pickers {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 25px;
  }

  .date-input {
    margin-bottom: 15px;
  }

  .participant-selectors {
    margin: 20px 0;
  }

  .selector-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .participant-input {
    margin-bottom: 15px;
  }

  .catering-options {
    margin-top: 20px;
  }

  .option-input {
    margin-bottom: 15px;
  }

  .fee-sections {
    display: grid;
    gap: 25px;
  }

  .fee-section {
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
  }

    .fee-section h3 {
      margin-top: 0;
      margin-bottom: 15px;
      color: #444;
      font-size: 18px;
    }

  .required-notice {
    display: block;
    margin-top: 20px;
    color: #999;
    font-size: 12px;
    text-align: right;
  }

  .dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #eee;
  }

  .cancel-btn {
    margin-right: 10px;
  }

  .reserve-btn {
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  /* Responsive adjustments */
  @media (max-width: 960px) {
    .facility-container {
      padding: 15px;
    }

    .gallery-container, .single-image-container {
      height: 400px;
    }

    .facility-title {
      font-size: 28px;
    }

    .capacity-display {
      flex-direction: column;
      gap: 10px;
    }

    .date-pickers, .selector-group {
      grid-template-columns: 1fr;
    }

    .nav-button {
      width: 40px;
      height: 40px;
    }
  }

  @media (max-width: 600px) {
    .gallery-container, .single-image-container {
      height: 300px;
    }

    .details-section {
      padding: 20px;
    }

    .facility-title {
      font-size: 24px;
    }

    .capacity-label {
      font-size: 14px;
    }

    .capacity-value {
      font-size: 16px;
    }

    .description-section {
      font-size: 15px;
    }

    .nav-button {
      width: 35px;
      height: 35px;
    }

      .nav-button.prev {
        left: 10px;
      }

      .nav-button.next {
        right: 10px;
      }

    .image-counter {
      font-size: 12px;
      padding: 3px 10px;
    }
  }
</style>
